import type { ComponentProps } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import ym from 'react-yandex-metrika';

import type { TeacherReserveAward } from '@edu-frontend/modules/src/features/teacherReserve';
import type { TeacherReserveAwardsCarousel } from '@edu-frontend/modules/src/widgets/teacherReserveCarousels';
import { useRouterPath, useStaticUrls } from 'platform-components';
import { getMe } from 'platform-components/src/components/user/selectors';

import { useAssignTeacherReservePromocode } from 'store/teacher-reserve';

export const useAwardCardHandlers = (): Pick<
    ComponentProps<typeof TeacherReserveAwardsCarousel>,
    'goToPortfolio' | 'onAssignPromocode' | 'onAwardCardButtonClick'
> => {
    const history = useHistory();

    const user_id = useSelector(getMe)?.id;

    const { labPortfolio } = useStaticUrls();
    const portfolioLink = useRouterPath(labPortfolio);

    const onAwardCardButtonClick = ({ id: award_id, status }: TeacherReserveAward) => {
        if (status === 'complete') {
            ym('reachGoal', 'teacher_talent_pool_get_award', { user_id, award_id });
        } else {
            ym('reachGoal', 'teacher_talent_pool_click_award', { user_id, award_id });
        }
    };

    const goToPortfolio = () => history.push(portfolioLink);

    const [assignPromocode] = useAssignTeacherReservePromocode();
    const onAssignPromocode = (awardId: string) => assignPromocode(awardId).then((v) => v!.promocode);

    return { onAwardCardButtonClick, goToPortfolio, onAssignPromocode };
};
